import { Fancybox } from '@fancyapps/ui';

document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll('.js-arch_scheme_trigger').forEach(trigger => {
		trigger.addEventListener('click', () => {
			const wrapper = trigger.closest('.js-arch_scheme');
			if (wrapper) {
				wrapper.classList.toggle('m-opened');
			}
		});
	});

	document.querySelectorAll('.js-arch_scheme_zoom').forEach(trigger => {
		trigger.addEventListener('click', (e) => {
			const src = e.currentTarget.dataset.src;
			if (!src) return;

			Fancybox.show([{ src, type: 'image' }]);
		});
	});
});
